import React, { useState } from 'react';
import { Grid, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RotatingLoader from '../common/ui/RotatingLoader';
import { useCatalogCategories } from './swr/useCatalogCategories';
import { CatalogItemsTab } from './CatalogItemsTab';
import { CatalogCategoriesTab } from './CatalogCategoriesTab';
import { CatalogEmptyState } from './CatalogEmptyState';
import { mb } from '../common/theme/mbTokens';

export const CatalogPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const { categories, isLoading } = useCatalogCategories();

  if (isLoading) {
    return (
      <Grid container justifyContent="center" alignItems="center" minHeight="200px">
        <RotatingLoader />
      </Grid>
    );
  }

  // Archived categories still count: only a truly untouched catalog gets the onboarding screen,
  // otherwise "show deleted" on the categories tab would become unreachable.
  if (categories.length === 0) {
    return (
      <Grid container flexDirection="column" flexWrap="nowrap" sx={{ height: '100%', overflow: 'auto' }}>
        <CatalogEmptyState />
      </Grid>
    );
  }

  return (
    <Grid container flexDirection="column" flexWrap="nowrap" sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
      <Grid sx={{ px: mb.layout.cardPadding, pt: mb.layout.cardPadding }}>
        <Tabs value={activeTab} onChange={(_, newTab) => setActiveTab(newTab)}>
          <Tab label={t('catalog.itemsTab')} />
          <Tab label={t('catalog.categoriesTab')} />
        </Tabs>
      </Grid>
      {activeTab === 0 ? <CatalogItemsTab /> : <CatalogCategoriesTab />}
    </Grid>
  );
};
